import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, SideCard } from "../../components";
import { ButtonType } from "../../components/button";
import { getCarList } from "../../redux/cars";
import { Car } from "../../redux/cars/types/car";
import { getLocalized } from "../../redux/localization";
import "./style.scss";
import { BsArrowRight } from "react-icons/bs";
import CarCard from "../../components/car-card";
import CustomLoader from "../../components/loader";
import { useHistory } from "react-router-dom";

const Campaigns = () => {
  const dispatch = useDispatch();
  const [cars, setCars] = useState<Car[]>([]);
  const localize = useSelector(getLocalized);
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  useEffect(() => {
    setLoader(true);
    dispatch(
      getCarList({
        payload: {
          onSuccess: (message, payload) => {
            setCars(payload.sort((a, b) => b.StartingPrice - a.StartingPrice));
            setLoader(false);
          },
          onError: (message) => {},
        },
        url: "api/car/web",
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container my-3  mb-5">
      <div className="w-100 d-flex flex-wrap campaignsBreadDiv">
        <h2 className="header-fontColored">{localize.getString("featured")}</h2>
        <Button
          buttonType={ButtonType.new}
          icon={<BsArrowRight />}
          title={"TÜM ARAÇLARI GÖSTER"}
          onClick={() => {
            history.push(`/cars`);
          }}
        />
      </div>
      <div className="w-100 d-flex  flex-wrap my-5 campaignsDiv">
        {cars.length <= 4
          ? cars.map((car: Car, i) => <CarCard key={i} data={car} />)
          : cars
              .slice(0, cars.length - (cars.length === 5 ? 1 : 2))
              .map((car: Car, i) => <CarCard key={i} data={car} />)}
      </div>
      <div
        className="w-100  flex-wrap my-5 campaignsDiv mobilesidecar"
        style={{ flexWrap: "wrap", gap: 16 }}
      >
        {cars.length > 4 &&
          cars
            .slice(cars.length - (cars.length === 5 ? 1 : 2), cars.length)
            .map((car: Car, i) => <CarCard key={i} data={car} />)}
      </div>
      <div
        className="divider-div mobilesidecardisplaynone"
        style={{ flexWrap: "wrap", gap: 16 }}
      >
        {cars.length > 4 &&
          cars
            .slice(cars.length - (cars.length === 5 ? 1 : 2), cars.length)
            .map((car: Car, i) => <SideCard key={i} data={car} />)}
      </div>

      {loader && <CustomLoader />}
    </div>
  );
};
export default Campaigns;
